import { render, staticRenderFns } from "./PosPay.vue?vue&type=template&id=b23741a2&"
import script from "./PosPay.vue?vue&type=script&lang=js&"
export * from "./PosPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports